import { useQuery } from '@tanstack/react-query';
import { type AxiosError } from 'axios';
import { useNavigate } from 'react-router-dom';

import { toast } from '@hivebrite/design-system/Toast';

import { QUERY_KEYS } from 'hb-react/frontoffice/apps/Forum/constants';
import { useForumContext } from 'hb-react/frontoffice/apps/Forum/contexts/ForumContext';
import { getEditDiscussion } from 'hb-react/frontoffice/apps/Forum/requests';
import { type Discussion } from 'hb-react/frontoffice/apps/Forum/types';
import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';

export const useGetEditDiscussion = (discussionId: number) => {
  const navigate = useNavigate();
  const { topicId } = useTopicContext();
  const { configUrls } = useForumContext();
  const {
    data: discussion,
    isLoading,
    isError,
    error,
  } = useQuery<Discussion, AxiosError>({
    queryKey: [QUERY_KEYS.editDiscussion, discussionId, topicId],
    queryFn: async () => {
      try {
        return await getEditDiscussion({
          discussionId,
          configUrls,
        });
      } catch (error) {
        if (error?.request?.status === 401) {
          navigate('..');
          toast.error(__('You are not authorized to access this page'));
        }
        throw error;
      }
    },
  });

  return { discussion, isLoading, isError, error };
};
